//import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import testData from "../testData/blogData.json";
import rina2 from "../assets/Rina2.JPG";
import rinaShiftkey from "../assets/RinaShiftkey.jpg";
import "../scss/_bottomHero.scss";

function BottomHero() {
    const { t } = useTranslation();
    const animation = {
        initial: {
            opacity: 0,
            y: 100,
        },
        animate: {
            opacity: 1,
            y: 0,
            transform: "skewY(-3.5deg)",
        },
    };

    return (
        <div className="heroPage">
            <div className="bottom">
                <div className="bottom-left">
                    <h1>{t("msgTitle")}</h1>
                    <p className="bottom-left-Rina">{t("rinaInfo")}</p>
                    <p> {t("msgDescription")} </p>
                </div>
                <motion.div
                    className="bottom-img1"
                    variants={animation}
                    initial="initial"
                    transition={{
                        delay: 0.45,
                    }}
                    whileInView="animate"
                    viewport={{
                        once: true,
                    }}
                >
                    <img alt={t("thirdImageAlt")} src={rina2} />
                </motion.div>
                <motion.div
                    className="bottom-img2"
                    variants={animation}
                    initial="initial"
                    transition={{
                        delay: 0.7,
                    }}
                    whileInView="animate"
                    viewport={{
                        once: true,
                    }}
                >
                    <img alt={t("thirdImageAlt")} src={rinaShiftkey} />
                </motion.div>
            </div>

            <BlogPosts t={t} />
            {/*
            <div className="contact">
                <div className="contact-right">
                    <h1>{t("reachOutTitle")}</h1>
                    <h1>{t("reachOutSubTitle")}</h1>
                    <p>{t("reachOutDescription")}</p>
                    <button className="contact-right button">
                        <FontAwesomeIcon
                            className="icon"
                            icon={faEnvelope}
                            size="50px"
                        />
                        {t("reachOut")}
                    </button>
                </div>
            </div>
            */}
        </div>
    );
}


const BlogPosts = ({ t }) => {
    return (
        <div className="updates">
            <div className="updates-title">
                <h1>{t("updatesTitle")}</h1>
                <p>{t("updatesDescription")}</p>
            </div>
            <div className="container">
                {testData.map((i, key) => (
                    <div className="card" key={key}>
                        <div className="img">
                            <img alt={i.alt} src={i.image} />
                        </div>
                        <p>{i.date}</p>
                        <h2>{i.title}</h2>
                        <p>{i.description}</p>
                        {getTags(i.tag)}
                    </div>
                ))}
            </div>
            <div className="updates-button">
                <Link to="/Research" className="view-more-button">
                    View More &gt;
                </Link>
            </div>
        </div>
    );
};

const getTags = (tagArray) => {
    return (
        <div className="tag">
            {tagArray.map((tag, index) => (
                <div className="tags" key={index}>
                    {tag}
                </div>
            ))}
        </div>
    );
};

export default BottomHero;
